// Generated by script, don't edit it please.
import createSvgIcon from '../../createSvgIcon';
import AngleRightSvg from '@rsuite/icon-font/lib/legacy/AngleRight';
var AngleRight = createSvgIcon({
    as: AngleRightSvg,
    ariaLabel: 'angle right',
    category: 'legacy',
    displayName: 'AngleRight'
});
export default AngleRight;
